const isNonProductionEnvironment = () =>
  process.env.NODE_ENV === 'development' || !!process.env.VERCEL_ENV;

export default isNonProductionEnvironment;
